/**
 * Zone/location definitions
 * Phase 1: Mountain Lake only
 */

import { ZoneDefinition } from '@/types';
import { BALANCE_CONFIG } from '../balance/balanceConfig';

/**
 * All zones in the game
 */
export const ZONE_DEFINITIONS: ZoneDefinition[] = [
  {
    id: 'mountain_lake',
    name: 'Mountain Lake',
    biome: 'alpine_lake',
    description: 'A pristine alpine lake teeming with wild trout.',

    // Fishing parameters
    fishPool: [
      'bluegill',
      'perch',
      'brook_trout',
      'cutthroat_trout',
      'trout', // Rainbow Trout
      'brown_trout',
      'bass', // Largemouth Bass
      'cuttbow_trout',
      'tiger_trout',
      'arctic_grayling',
    ],
    trapPool: [
      'crawdad',
      'signal_crayfish',
      'rusty_crayfish',
      'freshwater_mussel',
    ],
    baseFishingTime: BALANCE_CONFIG.BASE_FISHING_TIME,
    baseCatchChance: BALANCE_CONFIG.BASE_CATCH_CHANCE,

    // Buddy configuration
    maxBuddies: 3, // Small lake can support 3 fishing buddies

    // Available services
    outfitters: ['lakeside_tackle'],
    markets: ['camp_chef'],

    // Visuals
    backgroundImage: '/assets/zones/mountain_lake.png',
    theme: 'alpine',
  },

  // Future zones (Phase 2+)
  // {
  //   id: 'coastal_ocean',
  //   name: 'Coastal Ocean',
  //   biome: 'saltwater',
  //   description: 'Deep sea fishing with bigger catches and bigger risks.',
  //   fishPool: ['mackerel', 'tuna', 'shark'],
  //   baseFishingTime: 5.0,
  //   baseCatchChance: 0.5,
  //   shops: ['harbor_tackle'],
  //   buyers: ['seafood_market'],
  //   unlockRequirement: {
  //     currency: 1000,
  //     previousZone: 'mountain_lake',
  //   },
  // },
];

/**
 * Zone lookup by ID (for fast access)
 */
const ZONE_MAP = new Map(ZONE_DEFINITIONS.map((zone) => [zone.id, zone]));

/**
 * Get zone definition by ID
 * @throws Error if zone not found
 */
export function getZoneDefinition(id: string): ZoneDefinition {
  const zone = ZONE_MAP.get(id);
  if (!zone) {
    throw new Error(`Zone not found: ${id}`);
  }
  return zone;
}

/**
 * Get all zones for a specific biome
 */
export function getZonesByBiome(biome: string): ZoneDefinition[] {
  return ZONE_DEFINITIONS.filter((z) => z.biome === biome);
}

/**
 * Check if zone ID exists
 */
export function zoneExists(id: string): boolean {
  return ZONE_MAP.has(id);
}

/**
 * Get the starting zone (first zone)
 */
export function getStartingZone(): ZoneDefinition {
  return ZONE_DEFINITIONS[0];
}
